export default __webpack_public_path__ + "static/media/undraw_Mobile_marketing_re_p77p.b0d81809.svg";